import { Grid } from "@mui/material";
import React from "react";
import IntakeProfile from "../Dcp Counsellor/IntakeProfile";
import Tasks from "../Dcp Tutoring/Tasks";
import { TaskCategory } from "../../common/const";
import Events from "./Events";
import RecentActivites from "../Dcp Counsellor/RecentActivities";

const Counselling = ({
    currentService,
    studentId,
    email
}) => {
    return (
        <Grid container spacing={2}>
            <Grid item sm={12}>
                <IntakeProfile 
                    fromMentor 
                    studentEmail={email}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <Tasks
                    fromMentor
                    label="Action Plan & Assigned Tasks"
                    isCounselling
                    options={TaskCategory}
                    currentService={currentService}
                    studentId={studentId}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <Events
                    label="Counseling Sessions"
                    currentService={currentService}
                    studentId={studentId}
                />
            </Grid>
            <Grid item sm={12}>
                <RecentActivites
                    fromMentor
                    studentId={studentId}
                />
            </Grid>
        </Grid>
    )
}

export default Counselling;